export const notificationTypesHeaderElements = [
  { label: "Módulo", value: "modulo", align: "inherit" },
  { label: "Estado", value: "estado", align: "inherit" },
  { label: "Título", value: "titulo", align: "inherit" },
];
